// Dawn leaves the mobile drawer open for same-page section links. Use its
// existing close method so native focus, scroll locking and animation survive.
document.addEventListener('click', (event) => {
  const link = event.target.closest('header-drawer a[href]');
  if (!link) return;
  const destination = new URL(link.href, window.location.href);
  if (
    destination.origin !== window.location.origin ||
    destination.pathname !== window.location.pathname ||
    !destination.hash
  ) return;

  const drawer = link.closest('header-drawer');
  const summary = drawer.mainDetailsToggle?.querySelector('summary');
  if (!summary || typeof drawer.closeMenuDrawer !== 'function') return;
  drawer.closeMenuDrawer(event, summary);
  summary.setAttribute('aria-expanded', 'false');
});
